export default __webpack_public_path__ + "ring-close-fill.815bdd366a4c2432.svg";